var Stat = (function () {
    function Stat(exerciseID, executionContectID) {
        this.timeStamp = Date.now();
        this.duration = 0;
        this.exerciseID = exerciseID;
        this.executionContextID = executionContectID;
    }
    return Stat;
}());
export { Stat };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Stat.ts.pre-build-optimizer.js